<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Transfer Management</h1>
    <transferExtraStore />
  </v-card>
</template>

<script>
import transferExtraStore from "@/components/back-office/Transfer/SetExtraStore";
export default {
  components: {
    transferExtraStore,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },

      {
        text: "Transfer extra store",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
</style>